import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const nav = useNavigate();
  const { clear } = useCart();
  const tries = useRef(0);

  useEffect(() => {
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          clear();
          nav(`/ordine/${data.code}`, { replace: true });
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch {
        return setState("failed");
      }
      if (++tries.current > 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <main className="max-w-xl mx-auto px-5 py-20" data-testid="payment-success-page">
      <span className="tag text-[#555]">Pagamento</span>
      <h1 className="font-display font-black text-4xl tracking-tight mt-1" data-testid="payment-status-text">
        {state === "checking" && "Verifica del pagamento in corso..."}
        {state === "failed" && "Pagamento non riuscito"}
        {state === "timeout" && "Stiamo ancora confermando il pagamento"}
      </h1>
      {state !== "checking" && (
        <p className="mt-4 text-[#555]">
          {state === "timeout" ? "Riceverai un'email di conferma appena completato." : "Nessun addebito è stato effettuato."}{" "}
          <Link to="/checkout" className="underline hover:text-[#FF3333]" data-testid="payment-retry-link">Torna al checkout</Link>
        </p>
      )}
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="max-w-xl mx-auto px-5 py-20" data-testid="payment-cancel-page">
      <span className="tag text-[#555]">Pagamento</span>
      <h1 className="font-display font-black text-4xl tracking-tight mt-1">Pagamento annullato</h1>
      <p className="mt-4 text-[#555]">
        Il tuo carrello è ancora qui. <Link to="/checkout" className="underline hover:text-[#FF3333]" data-testid="payment-cancel-retry">Riprova</Link>
      </p>
    </main>
  );
}
